import { ChangeEvent, FormEvent, RefObject, useRef, useState } from 'react';

export type ControlledSearchBoxProps = React.ComponentProps<'div'> & {
  inputRef: RefObject<HTMLInputElement | null>;
  onChange(event: ChangeEvent): void;
  onReset(event: FormEvent): void;
  onSubmit?(event: FormEvent): void;
  placeholder?: string;
  value: string;
};

type SearchBoxProps = {
  children: (state: {
    value: string;
    inputRef: RefObject<HTMLInputElement | null>;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onReset: () => void;
    placeholder: string;
  }) => React.ReactNode;
  placeholder?: string;
};

const SearchBoxWrapper = ({
  children,
  placeholder = 'Search products...',
}: SearchBoxProps) => {
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const onReset = () => {
    setValue('');
  };

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.currentTarget.value);
  };

  const state = {
    value,
    inputRef,
    onChange,
    onReset,
    placeholder,
  };

  return children(state) as React.ReactElement;
};

export default SearchBoxWrapper;
